export enum ACTIVITY_TYPE {
  FILE = 1,
  INTERNAL = 2,
  EXTERNAL = 3,
}
